import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
  // baseURL: "http://127.0.0.1:9527",
    baseURL: "https://wxapi.huaheic.com",

  timeout: 30000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    return Promise.reject(error)
  }
)

// 请求工具类
const request = {
  /**
   * 通用请求方法
   * @param {string} type - 请求类型 (get/post/put/delete)
   * @param {string} url - 请求URL
   * @param {object} params - 请求参数
   * @returns {Promise}
   */
  send(type, url, params = {}) {
    const method = type.toLowerCase()
    const config = {
      url: url,
      method: method
    }

    // 根据请求类型设置参数
    if (method === 'get' || method === 'delete') {
      config.params = params
    } else {
      config.data = params
    }

    return service(config)
  },

  // 快捷方法
  get(url, params) {
    return this.send('get', url, params)
  },

  post(url, params) {
    return this.send('post', url, params)
  },

  put(url, params) {
    return this.send('put', url, params)
  },

  delete(url, params) {
    return this.send('delete', url, params)
  }
}

export default request
